import React from 'react'
import { connect } from 'react-redux'
import { Button } from '@material-ui/core'
import { buttonStyles } from '../styles/styles'
import { browserHistory } from 'react-router'
import LZString from 'lz-string'
import { cancel } from '../actions/main'
import { setSettings } from '../actions/settings'


const CancelFormButton = ({ main, settings, setSettings, cancel}) => {
    const buttonStyle = buttonStyles()
    //const isDisabled = main.selectedForm == null

    const handleCancel = () => {
        

        cancel();
        if (main.selectedForm != null) {
            let config = JSON.parse(LZString.decompressFromBase64(main.selectedForm.Config));
            setSettings(main.selectedForm, config)
        }
        browserHistory.push("/settings")
        if (settings.fromEditor) {
            // then we want to CLOSE the form editor, instead of going "back" to the form manager
            let data = {
                type: "close_form",
            }
            window.parent.postMessage(JSON.stringify(data), "*")
        }
    }
//{/*disabled={isDisabled}*/}
    return(
        <Button 
            className={buttonStyle.cancel}
            
            onClick={() =>handleCancel()}
            >
                Cancel
        </Button>
    )
} 

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    cancel: (currentView) => dispatch(cancel(currentView)),
    setSettings: (form, config) => dispatch(setSettings(form, config))
})

export default connect(mapStateToProps, mapDispatchToProps)(CancelFormButton)